/* tslint:disable */
/* eslint-disable */
/* @relayHash 5c814bc2667c528cd939306f11e3fee9 */

import { ConcreteRequest } from "relay-runtime";
export type FirmDesignProfileWeblinksMutationInput = {
    serviceId: string;
    facebook?: string | null;
    pinterest?: string | null;
    instagram?: string | null;
    website?: string | null;
    clientMutationId?: string | null;
};
export type profileWeblinksMutationVariables = {
    input: FirmDesignProfileWeblinksMutationInput;
};
export type profileWeblinksMutationResponse = {
    readonly firmDesignProfileWeblinksMutation: {
        readonly tradeFirm: {
            readonly publicProfile: {
                readonly webLinks: {
                    readonly website: string | null;
                    readonly facebook: string | null;
                    readonly instagram: string | null;
                    readonly pinterest: string | null;
                } | null;
            } | null;
        } | null;
    } | null;
};
export type profileWeblinksMutation = {
    readonly response: profileWeblinksMutationResponse;
    readonly variables: profileWeblinksMutationVariables;
};



const node: ConcreteRequest = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "FirmDesignProfileWeblinksMutationInput!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "publicProfile",
  "storageKey": null,
  "args": null,
  "concreteType": "TradeFirmPublicProfileType",
  "plural": false,
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "webLinks",
      "storageKey": null,
      "args": null,
      "concreteType": "WebLinkType",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "website",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "facebook",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "instagram",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "pinterest",
          "args": null,
          "storageKey": null
        }
      ]
    }
  ]
};
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "profileWeblinksMutation",
    "type": "Mutations",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "firmDesignProfileWeblinksMutation",
        "storageKey": null,
        "args": (v1/*: any*/),
        "concreteType": "FirmDesignProfileWeblinksMutationPayload",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "tradeFirm",
            "storageKey": null,
            "args": null,
            "concreteType": "TradeFirmType",
            "plural": false,
            "selections": [
              (v2/*: any*/)
            ]
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "profileWeblinksMutation",
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "firmDesignProfileWeblinksMutation",
        "storageKey": null,
        "args": (v1/*: any*/),
        "concreteType": "FirmDesignProfileWeblinksMutationPayload",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "tradeFirm",
            "storageKey": null,
            "args": null,
            "concreteType": "TradeFirmType",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "id",
                "args": null,
                "storageKey": null
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "operationKind": "mutation",
    "name": "profileWeblinksMutation",
    "id": "app-buyer-trade/267.0.0-2020-06-02T16:23:38.038Z/profileWeblinksMutation",
    "text": null,
    "metadata": {}
  }
};
})();
(node as any).hash = '3ec3613f2ca5840f93342418bc819322';
export default node;
